
    <template>
      <section class="relax-doc">
        <h1>Grid 栅格</h1>
<blockquote>
<p>24 栅格系统</p>
</blockquote>
<div class="components-grid-demo">
  <x-row>
    <x-col :span="24" class="color1">24: 100%</x-col>
  </x-row>
  <x-row>
    <x-col :span="12" class="color2">12: 50%</x-col>
    <x-col :span="12" class="color3">12: 50%</x-col>
  </x-row>
  <x-row>
    <x-col :span="8" class="color1">8: 33.33%</x-col>
    <x-col :span="8" class="color2">8: 33.33%</x-col>
    <x-col :span="8" class="color1">8: 33.33%</x-col>
  </x-row>
  <x-row>
    <x-col :span="6" class="color3">6: 25%</x-col>
    <x-col :span="6" class="color2">6: 25%</x-col>
    <x-col :span="6" class="color3">6: 25%</x-col>
    <x-col :span="6" class="color2">6: 25%</x-col>
  </x-row>
  <x-row>
    <x-col :span="16" class="color1">16: 66.66%</x-col>
    <x-col :span="8" class="color2">8: 33.33%</x-col>
  </x-row>
</div>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p><code>col</code> 必须放在 <code>row</code> 里面</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-row&gt;
    &lt;x-col :span=&quot;12&quot;&gt;&lt;div&gt;col-12&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;12&quot;&gt;&lt;div&gt;col-12&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
  &lt;x-row&gt;
    &lt;x-col :span=&quot;8&quot;&gt;&lt;div&gt;col-8&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;8&quot;&gt;&lt;div&gt;col-8&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;8&quot;&gt;&lt;div&gt;col-8&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
  &lt;x-row&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div&gt;col-6&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div&gt;col-6&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div&gt;col-6&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div&gt;col-6&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="qu-kuai-jian-ge"><a class="header-anchor" href="#qu-kuai-jian-ge"></a> 区块间隔</h2>
<blockquote>
<p>通过给 <code>row</code> 添加 <code>gutter</code> 属性，可以给下属的 <code>col</code> 添加间距</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-row :gutter=&quot;20&quot;&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div&gt;col-6&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div&gt;col-6&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div&gt;col-6&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div&gt;col-6&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="flexbu-ju"><a class="header-anchor" href="#flexbu-ju"></a> flex布局</h2>
<blockquote>
<p>通过给 <code>row</code> 设置参数 <code>justify</code> 为不同的值，来定义子元素的排布方式。在 <code>flex</code> 模式下有效。</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-row type=&quot;flex&quot; justify=&quot;start&quot;&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
  &lt;x-row type=&quot;flex&quot; justify=&quot;end&quot;&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
  &lt;x-row type=&quot;flex&quot; justify=&quot;center&quot;&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
  &lt;x-row type=&quot;flex&quot; justify=&quot;space-between&quot;&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
  &lt;x-row type=&quot;flex&quot; justify=&quot;space-around&quot;&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;4&quot;&gt;&lt;div&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="flexdui-qi"><a class="header-anchor" href="#flexdui-qi"></a> flex对齐</h2>
<blockquote>
<p>通过给 <code>row</code> 设置参数 <code>align</code> 为不同的值，来定义子元素在垂直方向上的排布方式。在 <code>flex</code> 模式下有效。</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo3 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-row type=&quot;flex&quot; justify=&quot;center&quot; align=&quot;top&quot;&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div style=&quot;height: 80px&quot;&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div style=&quot;height: 30px&quot;&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div style=&quot;height: 100px&quot;&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div style=&quot;height: 60px&quot;&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
  &lt;x-row type=&quot;flex&quot; justify=&quot;center&quot; align=&quot;center&quot;&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div style=&quot;height: 80px&quot;&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div style=&quot;height: 30px&quot;&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div style=&quot;height: 100px&quot;&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div style=&quot;height: 60px&quot;&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
  &lt;x-row type=&quot;flex&quot; justify=&quot;center&quot; align=&quot;bottom&quot;&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div style=&quot;height: 80px&quot;&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div style=&quot;height: 30px&quot;&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div style=&quot;height: 100px&quot;&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot;&gt;&lt;div style=&quot;height: 60px&quot;&gt;col-4&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="zha-ge-shun-xu"><a class="header-anchor" href="#zha-ge-shun-xu"></a> 栅格顺序</h2>
<blockquote>
<p>通过 <code>flex</code> 布局的 <code>order</code> 来改变栅格的顺序</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo4 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-row type=&quot;flex&quot;&gt;
    &lt;x-col :span=&quot;6&quot; :order=&quot;4&quot;&gt;&lt;div&gt;1 | order-4&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot; :order=&quot;3&quot;&gt;&lt;div&gt;2 | order-3&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot; :order=&quot;2&quot;&gt;&lt;div&gt;3 | order-2&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot; :order=&quot;1&quot;&gt;&lt;div&gt;4 | order-1&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="zuo-you-pian-yi"><a class="header-anchor" href="#zuo-you-pian-yi"></a> 左右偏移</h2>
<blockquote>
<p>通过设置 <code>offset</code> 属性，将列进行左右偏移</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo5 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-row&gt;
    &lt;x-col :span=&quot;8&quot;&gt;&lt;div&gt;col-8&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;8&quot; :offset=&quot;8&quot;&gt;&lt;div&gt;col-8 | offset-8&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
  &lt;x-row&gt;
    &lt;x-col :span=&quot;6&quot; :offset=&quot;8&quot;&gt;&lt;div&gt;col-6 | offset-8&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :span=&quot;6&quot; :offset=&quot;4&quot;&gt;&lt;div&gt;col-6 | offset-4&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
  &lt;x-row&gt;
    &lt;x-col :span=&quot;12&quot; :offset=&quot;8&quot;&gt;&lt;div&gt;col-12 | offset-8&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="xiang-ying-shi-bu-ju"><a class="header-anchor" href="#xiang-ying-shi-bu-ju"></a> 响应式布局</h2>
<blockquote>
<p>参照 <code>Bootstrap</code> 的 响应式设计，预设四个响应尺寸：<code>xs</code> <code>sm</code> <code>md</code> <code>lg</code> <br>
调整浏览器尺寸来查看效果</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo6 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-row&gt;
    &lt;x-col :xs=&quot;24&quot; :sm=&quot;12&quot; :md=&quot;8&quot; :lg=&quot;4&quot;&gt;&lt;div&gt;col&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :xs=&quot;24&quot; :sm=&quot;12&quot; :md=&quot;8&quot; :lg=&quot;4&quot;&gt;&lt;div&gt;col&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :xs=&quot;24&quot; :sm=&quot;12&quot; :md=&quot;8&quot; :lg=&quot;4&quot;&gt;&lt;div&gt;col&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :xs=&quot;24&quot; :sm=&quot;12&quot; :md=&quot;8&quot; :lg=&quot;4&quot;&gt;&lt;div&gt;col&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :xs=&quot;24&quot; :sm=&quot;12&quot; :md=&quot;8&quot; :lg=&quot;4&quot;&gt;&lt;div&gt;col&lt;/div&gt;&lt;/x-col&gt;
    &lt;x-col :xs=&quot;24&quot; :sm=&quot;12&quot; :md=&quot;8&quot; :lg=&quot;4&quot;&gt;&lt;div&gt;col&lt;/div&gt;&lt;/x-col&gt;
  &lt;/x-row&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { createElementVNode: _createElementVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_col = _resolveComponent("x-col")
  const _component_x_row = _resolveComponent("x-row")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-12")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-12")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 8 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-8")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 8 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-8")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 8 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-8")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-6")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-6")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-6")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-6")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { createElementVNode: _createElementVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_col = _resolveComponent("x-col")
  const _component_x_row = _resolveComponent("x-row")

  return (_openBlock(), _createBlock(_component_x_row, { gutter: 20 }, {
    default: _withCtx(() => [
      _createVNode(_component_x_col, { span: 6 }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "col-6")
        ]),
        _: 1
      }),
      _createVNode(_component_x_col, { span: 6 }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "col-6")
        ]),
        _: 1
      }),
      _createVNode(_component_x_col, { span: 6 }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "col-6")
        ]),
        _: 1
      }),
      _createVNode(_component_x_col, { span: 6 }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "col-6")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { createElementVNode: _createElementVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_col = _resolveComponent("x-col")
  const _component_x_row = _resolveComponent("x-row")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "start"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "end"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "space-around"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-4")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    const { createElementVNode: _createElementVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_col = _resolveComponent("x-col")
  const _component_x_row = _resolveComponent("x-row")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "center",
      align: "top"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", { style: {"height":"80px"} }, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", { style: {"height":"30px"} }, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", { style: {"height":"100px"} }, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", { style: {"height":"60px"} }, "col-4")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "center",
      align: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", { style: {"height":"80px"} }, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", { style: {"height":"30px"} }, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", { style: {"height":"100px"} }, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", { style: {"height":"60px"} }, "col-4")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "center",
      align: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", { style: {"height":"80px"} }, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", { style: {"height":"30px"} }, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", { style: {"height":"100px"} }, "col-4")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", { style: {"height":"60px"} }, "col-4")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo4": (function() {
    
    const { createElementVNode: _createElementVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_col = _resolveComponent("x-col")
  const _component_x_row = _resolveComponent("x-row")

  return (_openBlock(), _createBlock(_component_x_row, { type: "flex" }, {
    default: _withCtx(() => [
      _createVNode(_component_x_col, {
        span: 6,
        order: 4
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "1 | order-4")
        ]),
        _: 1
      }),
      _createVNode(_component_x_col, {
        span: 6,
        order: 3
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "2 | order-3")
        ]),
        _: 1
      }),
      _createVNode(_component_x_col, {
        span: 6,
        order: 2
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "3 | order-2")
        ]),
        _: 1
      }),
      _createVNode(_component_x_col, {
        span: 6,
        order: 1
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "4 | order-1")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo5": (function() {
    
    const { createElementVNode: _createElementVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_col = _resolveComponent("x-col")
  const _component_x_row = _resolveComponent("x-row")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 8 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-8")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, {
          span: 8,
          offset: 8
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-8 | offset-8")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, {
          span: 6,
          offset: 8
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-6 | offset-8")
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, {
          span: 6,
          offset: 4
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-6 | offset-4")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, {
          span: 12,
          offset: 8
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "col-12 | offset-8")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo6": (function() {
    
    const { createElementVNode: _createElementVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_col = _resolveComponent("x-col")
  const _component_x_row = _resolveComponent("x-row")

  return (_openBlock(), _createBlock(_component_x_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_x_col, {
        xs: 24,
        sm: 12,
        md: 8,
        lg: 4
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "col")
        ]),
        _: 1
      }),
      _createVNode(_component_x_col, {
        xs: 24,
        sm: 12,
        md: 8,
        lg: 4
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "col")
        ]),
        _: 1
      }),
      _createVNode(_component_x_col, {
        xs: 24,
        sm: 12,
        md: 8,
        lg: 4
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "col")
        ]),
        _: 1
      }),
      _createVNode(_component_x_col, {
        xs: 24,
        sm: 12,
        md: 8,
        lg: 4
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "col")
        ]),
        _: 1
      }),
      _createVNode(_component_x_col, {
        xs: 24,
        sm: 12,
        md: 8,
        lg: 4
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "col")
        ]),
        _: 1
      }),
      _createVNode(_component_x_col, {
        xs: 24,
        sm: 12,
        md: 8,
        lg: 4
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "col")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  